export default "__VITE_ASSET__DutaMvn9__"